import type { FaireProductEntity } from "../../entity_types/product";

export const p_9kcvcb5wqm: FaireProductEntity = {
  token: "p_9kcvcb5wqm",
  type: "product",
  name: "Holland Tulip Studs - 18K Gold Plated or Silver Rhodium",
  brandToken: "b_5fhorwgw5m",
  brandName: "Peter and June",
  imageUrl:
    "https://cdn.faire.com/fastly/ec6c052a2590ede428c87612ebbbc16e81600acc034655109e58199a6c456f94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91a43d3c7d79c75af197eee20dca450c6c676f8146d2cdca97572f6200c867a1.jpeg",
    "https://cdn.faire.com/fastly/cf5ac9c2dadefdd23212715c758f505148aa0e275ac2b52d6ba12e0588d362bd.jpeg",
    "https://cdn.faire.com/fastly/5b423060cc7fbec5a92bce8ff9530d7e19236ad0ad7e322a67f6f9f20729715d.jpeg",
    "https://cdn.faire.com/fastly/9ae3eb474e7d34e81f6b46f82e1a5fcb0016248238ece784750003646cd15c66.jpeg",
  ],
  priceDollars: 13,
  description:
    "• 18k gold plated over brass or silver rhodium\n• water resistant\n• about 2.5cm x 0.5cm\n• nickel / lead free\n• made with materials ethically sourced",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:49.873Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
